module.exports = __webpack_public_path__ + "img/1.b1b80d8e.png";